import { render, staticRenderFns } from "./TeamOrientations.vue?vue&type=template&id=76a9f6c4&scoped=true"
import script from "./TeamOrientations.vue?vue&type=script&lang=ts"
export * from "./TeamOrientations.vue?vue&type=script&lang=ts"
import style0 from "./TeamOrientations.vue?vue&type=style&index=0&id=76a9f6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9f6c4",
  null
  
)

export default component.exports